<script setup>
import { useStore } from 'vuex'
import { RHDHVHeader } from '@haskoning/vue-component-library'
import CommentButton from '@/components/app/CommentButton.vue'
import BreadCrumb from '@/components/app/BreadCrumb.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import SidebarToggleButton from '@/components/app/SidebarToggleButton.vue'
import RightAppBarButton from '@/components/app/RightAppBarButton.vue'
import { useProjectSpeckleStore } from '@/store/projectSpeckle'
import { storeToRefs } from 'pinia'

const route = useRoute()
const store = useStore()
const router = useRouter()
const projectSpeckleStore = useProjectSpeckleStore()

const projectLoading = computed(() => store.state.project.loading)
const dikeSectionLoading = computed(() => store.state.dikeSection.loading)
const referencePointLoading = computed(() => store.state.referencePoint.loading)
const dikeProfileLoading = computed(() => store.state.dikeProfiles.loading)
const commentLoading = computed(() => store.state.comment.loading)
const yearsLoading = computed(() => store.state.years.loading)

const isLoading = computed(
  () =>
    projectLoading.value ||
    commentLoading.value ||
    dikeSectionLoading.value ||
    referencePointLoading.value ||
    dikeProfileLoading.value ||
    yearsLoading.value
)

const currentUser = computed(() => store.state.users.currentUser)

const authenticateLogout = () => store.dispatch('authenticate/logout')

const logout = () => {
  projectSpeckleStore.logout()
  authenticateLogout()
}

const goToProjectIndex = () => {
  router.push({ name: 'project-index' })
}

const shownCommentButton = computed(() => !route.meta.hideSideBar)
</script>

<template>
  <RHDHVHeader
    title="PACE"
    :user="currentUser"
    image-src="/logo-rhdhv-white.png"
    :loading="isLoading"
    menuColor="white"
    @logo-click="goToProjectIndex"
    @logout="logout"
  >
    <template v-if="shownCommentButton" v-slot:toolbar-prepend>
      <SidebarToggleButton />
    </template>
    <template v-slot:breadcrumbs-items>
      <BreadCrumb />
    </template>
    <template v-slot:toolbar-extension>
      <v-divider v-if="shownCommentButton" class="mx-2" vertical></v-divider>
      <CommentButton v-if="shownCommentButton" />
      <v-divider v-if="shownCommentButton" class="mx-2" vertical></v-divider>
      <RightAppBarButton />
    </template>
  </RHDHVHeader>
</template>
